import axios from 'axios';


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true

})

export class UsersFetchAPI {
    //Funtion to get the business users 
    static async getBusinessUser(business_id) {
        const res = await server(`/users/${business_id}/business`, {
            method: "get",
        });
        return res;
    }

    //Function to get users by role and branchoffice
    static async getUsersByRoleAndBranchoffice(branchoffice_id, users_role_id) {
        const res = await server(`/users/${branchoffice_id}/branchoffice/${users_role_id}/role`, {
            method: "get",
        });
        return res;
    }

    //Function to get users by role and business
    static async getUsesByBusinessAndRole(business_id, users_role_id, token) {
        let final_string_users_role_id = "role=" + users_role_id.join("&role=")
        const res = await server(`/users/${business_id}/business?${final_string_users_role_id}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,

        });
        return res;
    }

    //Function to get user by code
    static async getUserById(id, token) {
        const res = await server(`/user/${id}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,

        });
        return res;
    }

    //Function to get user by code
    static async getUserByCode(code, token) {
        const res = await server(`/user/${code}/user_code`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,

        });
        return res;
    }

    //Function to get user by code and password
    static async getUserByCodeAndPassword(code, password, token) {
        const res = await server(`/user/${code}/user_code`, {
            method: "post",
            headers: token ? { 'x-access-token': token } : undefined,

            data: {
                password: password
            }
        });
        return res;
    }


    //Function to get user by idCard
    static async getUserByIdCard(idCard, token) {
        const res = await server(`/user/${idCard}/idCard?role=4`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,

        });
        return res;
    }

    //Function to get user by access 
    static async    getUsersByPermissionAccess(branchoffice_id, access, token) {
        const res = await server(`/user/product/permission_access?branchoffice_id=${branchoffice_id}&access=${access}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res;
    }

}